import { LocationOn as LocationIcon, PersonOutline as PersonIcon } from '@mui/icons-material';
import { ShippingApi } from '../../../../Shippings/models/Shipping';
import { Typography, Skeleton } from '@mui/material';
import React from 'react';

interface ShippingDetailsProps {
  shipping?: ShippingApi;
  isLoading: boolean;
}

const ShippingDetails: React.FC<ShippingDetailsProps> = ({ shipping, isLoading }) => {
  if (isLoading) {
    return (
      <div className='flex flex-col border-l border-gray-100 pl-6 flex-1'>
        <Skeleton width={200} height={40} />
      </div>
    );
  }

  return (
    <div className='flex flex-col border-l border-gray-100 pl-6 py-1 flex-1 min-w-0'>
      <div className='flex items-center gap-2 mb-0.5'>
        <LocationIcon sx={{ fontSize: 18, color: '#94a3b8' }} />
        <Typography 
          sx={{ 
            fontWeight: 600, 
            color: '#334155',
            fontSize: '1.1rem',
            lineHeight: 1.2,
            textTransform: 'uppercase',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {shipping?.destinationAddress 
            ? `${shipping.destinationAddress.streetName} ${shipping.destinationAddress.doorNumber}${shipping.destinationNeighborhood?.name ? `, ${shipping.destinationNeighborhood.name}` : ''}`
            : 'Sin dirección'}
        </Typography>
      </div>
      
      <div className='flex items-center gap-2'>
        <PersonIcon sx={{ fontSize: 16, color: '#94a3b8' }} />
        <Typography 
          sx={{ 
            color: '#64748b',
            fontSize: '0.9rem',
            fontWeight: 500,
            maxWidth: '400px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {shipping?.recipient || 'Sin nombre'}
        </Typography>
      </div>
      
      <div className='flex items-center gap-2 mt-1.5'>
        <span className='text-[8px] font-black bg-gray-50 px-1.5 py-0.5 rounded text-gray-400 uppercase tracking-tighter border border-gray-100'>
          Comercio
        </span>
        <span className='text-[11px] font-bold text-gray-400 uppercase'>
          {shipping?.commerce?.name || '-'}
        </span>
      </div>
    </div>
  );
};

export default ShippingDetails;
